<template>
  <div>
    <label>Lager</label>
    <div class="w-100">
      <multiselect :value="value"
        :options="options"
        track-by="id"
        label="short_name"
        @input="input"
        placeholder="Lager auswählen"
        :allow-empty="allowEmpty"
      />
      <div class="text-danger invalid-feedback" style="display: block;"
        v-if="error"
      >
        Lager muss ausgewählt werden.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: null,
    options: null,
    allowEmpty: {
      default: true
    },
    error: {
      default: false
    }
  },
  methods: {
    input (warehouse) {
      this.$emit('input', warehouse)
      if (warehouse) {
        this.$store.state.filters.warehouse = warehouse
      }
    }
  }
}
</script>

<style>
</style>
